import { render, staticRenderFns } from "./question-element.vue?vue&type=template&id=79152066&scoped=true"
import script from "./question-element.vue?vue&type=script&lang=js"
export * from "./question-element.vue?vue&type=script&lang=js"
import style0 from "./question-element.vue?vue&type=style&index=0&id=79152066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79152066",
  null
  
)

export default component.exports